function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentcolor",
  fillRule: "evenodd",
  stroke: "#1A8BDE",
  strokeWidth: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.69 8.5a.388.388 0 0 1-.392-.393c0-.221.172-.393.393-.393h2.302c.22 0 .393.172.393.393a.404.404 0 0 1-.393.393H14.69zm-13.297 0A.388.388 0 0 1 1 8.107c0-.221.172-.393.393-.393h9.205c.221 0 .393.172.393.393-.024.196-.196.393-.417.393H1.393z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.62 6.584c-.835 0-1.499.688-1.499 1.499 0 .835.688 1.498 1.499 1.498.835 0 1.499-.688 1.499-1.498 0-.811-.664-1.5-1.499-1.5m0 3.809a2.28 2.28 0 0 1-2.285-2.285 2.28 2.28 0 0 1 2.285-2.285 2.28 2.28 0 0 1 2.285 2.285 2.296 2.296 0 0 1-2.285 2.285M3.695 2.923a.388.388 0 0 0 .393-.393.388.388 0 0 0-.393-.393H1.393A.388.388 0 0 0 1 2.53c0 .222.172.393.393.393h2.302z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.243 2.53c0 .836.688 1.5 1.498 1.5.836 0 1.499-.689 1.499-1.5 0-.835-.688-1.498-1.499-1.498-.81 0-1.498.663-1.498 1.498m-.786 0A2.28 2.28 0 0 1 5.74.246 2.28 2.28 0 0 1 8.026 2.53a2.28 2.28 0 0 1-2.285 2.285C4.488 4.84 3.457 3.808 3.457 2.53"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.993 2.923a.388.388 0 0 0 .393-.393.388.388 0 0 0-.393-.393H7.788a.388.388 0 0 0-.393.393c0 .222.172.393.393.393h9.205z"
}));

const SvgFilters = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilters, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filters.cde599fc.svg";
export { ForwardRef as ReactComponent };